module.exports = __webpack_public_path__ + "static/rarechicago-officeanime-f198d0571ee5987fabc8b08cff0221b7.svg";